import { VendorsearchService } from './../../services/vendor/vendorsearch.service';
import { ManageComplaintsService } from './../../services/manage-complaints/manage-complaints.service';
import { ComplaintsDropDownService } from './../../services/complaints_drop_down/complaints-drop-down.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import {Component, OnInit, Inject, Input, OnDestroy} from '@angular/core';
import { NgForm } from '@angular/forms';
import * as momenttimezone from 'moment-timezone';
import { environment } from '../../../environments/environment';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';
import { SharedVals } from '../../../shared/SharedVals';
import { ISubscription } from 'rxjs/Subscription';

declare let ga: any;
@Component({
  selector: 'app-new-complaints-dialog',
  templateUrl: './new-complaints-dialog.component.html',
  styleUrls: ['./new-complaints-dialog.component.css']
})
export class NewComplaintsDialogComponent implements OnInit, OnDestroy {
  selectedValue: string;
  categories = [];
  complaintType = [];
  complaintSource = [];
  usersList = [];
  vendorLocationList = [];
  resolutionList = [];
  resolutionTypeList = [];
  idInfoList = [];
  vendorname = [];
  public errMsg: any;
  public typeErr1: boolean = false;
  public disableField: boolean = false;
  isResolutionHidden: boolean;
  disableIdField: boolean;
  matchStatus: boolean;
  inputFieldRequired: boolean;
  minDate = new Date();
  public submitFormData: any;
  public editData: any;
  updateList: any;
  relateComplaintData: any;
  activeFlag: boolean = false;
  state;
  cmpId;
  vendor_details;
  vendor_name;
  vendor_id;
  vendorEmailId: any;
  subscription: ISubscription;

  controllable: controllableList[] = [
    { value: "Yes" },
    { value: "No" }
  ];

  data = {
    ParStockNumber: '',
    VIN: '',
    FirstName: '',
    LastName: '',
    Make: '',
    Year: '',
    Model: '',
    Category: '',
    ComplaintType: '',
    ComplaintSource: '',
    MasterVendorName: '',
    VendorLocationId: '',
    MasterVendorId: '',
    RepoDate: null,
    IncidentDate: '',
    ClientName: '',
    ClaimStartDate: new Date(),
    Complainant: '',
    Phone: '',
    Email: '',
    UserName: '',
    State: '',
    Resolution: '',
    Controllable: '',
    ResolutionDate: '',
    ResolutionNotes: '',
    ComplaintStatus: true,
    Completed: false,
    SentEmail: false,
    EmailType: '',
    EmailTypeVal: '',
    ResolutionType: '',
    resolutionAmount: ''
  }

  ManageTypeErrMsg: string;
  ManageTypeErr: boolean;
  loginId: string;
  MasterVendorId: any;
  locationId;
  master_vendor_Id: any;
  Isedit: boolean = false;
  editMasterVendorID: any;
  complaintValue: number;
  title: string;
  resolutionFields: boolean;
  IsCompleted: boolean;
  IsCompletedChecked: boolean = false;
  invalidId: boolean = false;
  emailTypeList: any;
  emailTypeval: any;
  matchedVendor: boolean = true;
  noLocationFound: boolean = false;
  disableDateField: boolean = false;
  firstName;
  lastName;
  disableVIN: boolean = true;
  disableFN: boolean = true;
  disableLN: boolean = true;
  disableMake: boolean = true;
  disableYear: boolean = true;
  disableModel: boolean = true;
  disableCN: boolean = true;

  constructor(public dialogRef: MatDialogRef<NewComplaintsDialogComponent>,
    private vendorService: VendorsearchService,
    public complaintsDropDown: ComplaintsDropDownService, public manageComplaint: ManageComplaintsService,
    @Inject(MAT_DIALOG_DATA) public newComplaint: any,
    private googleAnalyticsService: GoogleAnalyticsService,
    public sharedVals: SharedVals) { }

  ngOnInit() {
    this.firstName = localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
    this.subscription = this.sharedVals.loginIdData.subscribe(data => {
      this.data.UserName = data;
    }, err => {
      
    });

    if (this.newComplaint.type && this.newComplaint.type === 'update') {
      this.Isedit = true;
    } else {
      this.Isedit = false;
    }
    this.loginId = localStorage.getItem("loginID");
    this.MasterVendorId = localStorage.getItem("AgentId");
    this.getComplaintsType();
    this.getCategory();
    this.getComplaintSource();
    this.getUsers();
    this.getResolution();
    this.getEmailTypeList();
    this.getResolutionType();
    if (this.newComplaint.status === 0 && this.newComplaint.type === "update") {
      this.title = "Edit Active Complaint";
      //this.disableField = true;
      this.disableVIN = true;
      this.disableFN = true;
      this.disableLN = true;
      this.disableMake = true;
      this.disableYear = true;
      this.disableModel = true;
      this.disableCN = true;
      this.disableIdField = true;
      this.disableDateField = true;
      this.matchStatus = true;
      this.getVendorLocation(this.newComplaint.complaintData.MasterVendorId);
    } else if (this.newComplaint.status === 0 && this.newComplaint.type === "relate") {
      this.title = "Relate Complaint";
      //this.disableField = true;
      this.disableVIN = true;
      this.disableFN = true;
      this.disableLN = true;
      this.disableMake = true;
      this.disableYear = true;
      this.disableModel = true;
      this.disableCN = true;
      this.disableIdField = true;
      this.disableDateField = true;
      this.resolutionFields = false;
      this.IsCompleted = false;
      this.matchStatus = true;
      this.resolutionFields = true;
      this.IsCompleted = true;
      this.getVendorLocation(this.newComplaint.complaintData.MasterVendorId);
    } else if (this.newComplaint.status === 1 && this.newComplaint.type === "update") {
      this.title = "Edit Inactive Complaint";
      this.activeFlag = true;
      //this.disableField = true;
      this.disableVIN = true;
      this.disableFN = true;
      this.disableLN = true;
      this.disableMake = true;
      this.disableYear = true;
      this.disableModel = true;
      this.disableCN = true;
      this.disableDateField = true;
      this.disableIdField = true;
      this.IsCompleted = true;
      this.matchStatus = true;
      this.getVendorLocation(this.newComplaint.complaintData.MasterVendorId);
    } else if (this.newComplaint.status === 1 && this.newComplaint.type === "relate") {
      this.title = "Relate Complaint";
      //this.disableField = true;
      this.disableVIN = true;
      this.disableFN = true;
      this.disableLN = true;
      this.disableMake = true;
      this.disableYear = true;
      this.disableModel = true;
      this.disableCN = true;
      this.disableIdField = true;
      this.disableDateField = true;
      this.matchStatus = true;
      this.resolutionFields = true;
      this.IsCompleted = true;
      this.vendorEmailId = this.newComplaint.complaintData.VendorEmail;
      this.getVendorLocation(this.newComplaint.complaintData.MasterVendorId);
    } else {
      this.title = "New Complaint";
      this.resolutionFields = true;
      this.IsCompleted = true;
    }
    if (this.newComplaint.type === 'update') {
      this.getActiveComplaintsDetailsToEdit();

      if (this.newComplaint.complaintData.Resolution !== null || this.newComplaint.complaintData.Resolution !== undefined) {
        if (this.newComplaint.complaintData.ResolutionType !== null || this.newComplaint.complaintData.ResolutionType !== undefined) {
          if (this.newComplaint.complaintData.Resolution !== 'Other' && this.newComplaint.complaintData.Resolution !== 'N/A' && this.newComplaint.complaintData.Resolution.length !== 0) {
            this.isResolutionHidden = true;
          } else {
            this.isResolutionHidden = false;
          }
        } else {
          this.isResolutionHidden = true;
        }
      } else if (this.newComplaint.complaintData.Resolution == '') {
        this.isResolutionHidden = false;
      }
      this.getVendorLocation(this.newComplaint.complaintData.MasterVendorId);
      // this.selectedEmailType(this.newComplaint.complaintData.EmailType);
      this.vendorEmailId = this.newComplaint.complaintData.VendorEmail;
    } else if (this.newComplaint.type === 'relate') {
      this.getComplaintsDetails();
      this.resolutionFields = true;
      this.IsCompleted = true;
      this.vendorEmailId = this.newComplaint.complaintData.VendorEmail;
    }
  }

  onKey(event: any, type) {
    if (type === 'Enter' || type === 'out') {
      this.idInfoList = [];
      const IdValue = event;
      this.complaintsDropDown.getIdData(IdValue).subscribe(res => {
        if (res) {
          this.disableVIN = true;
          this.disableFN = true;
          this.disableLN = true;
          this.disableMake = true;
          this.disableYear = true;
          this.disableModel = true;
          this.disableCN = true;
          this.invalidId = false;
          let VIPRDetails = res.VIPRDetails;
          this.data.VIN = VIPRDetails.VIN;
          this.data.FirstName = VIPRDetails.FirstName;
          this.data.LastName = VIPRDetails.LastName;
          this.data.Make = VIPRDetails.Make;
          this.data.Year = String(VIPRDetails.Year);
          this.data.Model = VIPRDetails.Model;
          this.data.ClientName = VIPRDetails.ClientName;
          this.data.RepoDate = (VIPRDetails.RepoDate == "" || VIPRDetails.RepoDate == "null") ? null : new Date(VIPRDetails.RepoDate);
          this.disableIdField = false;
          this.disableDateField = true;
          //this.disableField=true;
          /*** Condition to allow user to enter data, if the following data is missing from VIPR for a given PAR# ***/
          if (this.data.FirstName === '' || this.data.FirstName === null)
            this.disableFN = false;
          if (this.data.LastName === '' || this.data.LastName === null)
            this.disableLN = false;
          if (this.data.VIN === '' || this.data.VIN === null)
            this.disableVIN = false;
          if (this.data.Make === '' || this.data.Make === null)
            this.disableMake = false;
          if (this.data.Year === '' || this.data.Year === null)
            this.disableYear = false;
          if (this.data.Model === '' || this.data.Model === null)
            this.disableModel = false;
          if (this.data.ClientName === '' || this.data.ClientName === null)
            this.disableCN = false;

        } else {
          this.errMsg = "No ID data found ";
        }
      }, err => {
        this.invalidId = true;
        //this.disableField = false;
        this.disableVIN = false;
        this.disableFN = false;
        this.disableLN = false;
        this.disableMake = false;
        this.disableYear = false;
        this.disableModel = false;
        this.disableCN = false;
        this.errMsg = "ID Service" + err;
        this.data.VIN = '';
        this.data.FirstName = '';
        this.data.LastName = '';
        this.data.Make = '';
        this.data.Year = '';
        this.data.Model = '';
        this.data.ClientName = '';
        this.data.RepoDate = '';
      });
    }
  }

  selectedVendor(value) {
    const data = this.vendorname.find(x => x.MasterVendorName.toLowerCase() === value.toLowerCase());
    this.data.MasterVendorName = data.MasterVendorName;
    this.vendorEmailId = data.Email;
    this.editMasterVendorID = data.MasterVendorId;
    this.getVendorLocation(data.MasterVendorId);
  }

  getEmailTypeList() {
    // this.emailTypeList = [];
    this.complaintsDropDown.getEmialTypeList().subscribe(res => {
      if (res) {
        this.emailTypeList = res.EmailType_drop_down_values;
        // emailType.forEach((element) => {
        //   this.emailTypeList.push(element.type);
        // });
      }
    });
  }
  // selectedEmailType(event) {
  //   this.complaintsDropDown.getEmialTypeList().subscribe(res => {
  //     if (res) {
  //       let emailType = res.EmailType_drop_down_values;
  //       var KeyVal = this.searchByKey(event, emailType);
  //       this.emailTypeval = KeyVal.value;
  //     }
  //   });
  // }

  // searchByKey(nameKey, myArray){
  //   for (var i=0; i < myArray.length; i++) {
  //     if (myArray[i].type == nameKey) {
  //         return myArray[i]
  //     }
  //   }
  // }

  search(value) {
    if (value != null && value != undefined) {
      if (value.length >= 3) {
        this.inputFieldRequired = false;
        let searchby = value;
        this.vendorService.getVendorEmail(searchby).subscribe(
          (users: any) => {
            this.vendorname = users.VendorInfo;
            this.matchStatus = true;
            users = null;
            if (this.vendorname === undefined) {
              this.matchedVendor = false;
            }
          }, err => {
            this.matchStatus = false;
            this.vendorLocationList = [];
            this.data.VendorLocationId = '';
          }
        );
      }
      else {
        if (value.length < 3) {
          this.matchStatus = false;
          this.matchedVendor = true;
        } else {
          this.matchStatus = true;
          this.matchedVendor = true;
        }
        // this.matchStatus = false;
        this.data.VendorLocationId = null;
        if (this.data.MasterVendorName.length === 0) {
          this.vendorLocationList = [];
        }
      }
    }
  }

  getResolution() {
    this.resolutionList = [];
    this.complaintsDropDown.getResolutionData().subscribe(res => {
      if (res && res.Resolution_drop_down_values && res.Resolution_drop_down_values.length > 0) {
        let resolutions = res.Resolution_drop_down_values;
        resolutions.forEach((element) => {
          this.resolutionList.push(element);
        });
      } else {
        this.errMsg = "No Resolution data found ";
        this.typeErr1 = true;
      }

    }, err => {
      this.errMsg = "Resolution Service" + err;
      this.typeErr1 = true;
    });
  }

  getResolutionType() {
    this.resolutionTypeList = [];
    this.complaintsDropDown.getResolutionTypeData().subscribe(res => {
      if (res && res.ResolutionType_drop_down_values && res.ResolutionType_drop_down_values.length > 0) {
        let resolutions_type = res.ResolutionType_drop_down_values;
        resolutions_type.forEach((element) => {
          this.resolutionTypeList.push(element);
        });
      } else {
        this.errMsg = "No Resolution Type data found ";
        this.typeErr1 = true;
      }

    }, err => {
      this.errMsg = "Resolution Type Service" + err;
      this.typeErr1 = true;
    });
  }
  getVendorLocation(vendorId) {
    this.vendorLocationList = [];
    this.complaintsDropDown.getLocationData(vendorId).subscribe(res => {
      if (res !== undefined && res !== '') {
        if (res.vendorLocationDetails !== undefined && res.vendorLocationDetails.length > 0) {
          this.vendorLocationList = res.vendorLocationDetails;
          this.noLocationFound = false;
          this.vendorLocationList.forEach((element) => {
            let address = []
            element.Address1 !== null ? address.push(element.Address1) : '';
            element.Address2 !== null ? address.push(element.Address2) : '';
            element.State !== null ? address.push(element.State) : '';
            element.PostalCode !== null ? address.push(element.PostalCode) : '';
            let fullAddress = address.join();
            element.fullAddress = fullAddress;
          });
        } else {
          this.noLocationFound = true;
        }
      } else {
        this.errMsg = "No Vendor Location data found ";
        this.typeErr1 = true;
      }
    }, err => {
      this.errMsg = "Users Vendor Location Service" + err;
      this.typeErr1 = true;
    });
  }

  getUsers() {
    this.usersList = [];
    this.complaintsDropDown.getUsers().subscribe(res => {
      if (res !== undefined && res !== '') {
        if (res.Users !== undefined && res.Users.length > 0) {
          let userList = res.Users;
          userList.forEach((element) => {
            if (element.IsActive === 'Y') {
              if (element.Role === 'ResolutionManager') {
                this.usersList.push(element.Email);
              }
            }
          });
        } else {
          this.errMsg = "No Users data found ";
          this.typeErr1 = false;
        }
      } else {
        this.errMsg = "No Users data found ";
        this.typeErr1 = false;
      }
    }, err => {
      this.errMsg = "Users Service " + err;
      this.typeErr1 = true;
    });
  }

  getComplaintSource() {
    this.complaintSource = [];
    this.complaintsDropDown.getComplaintSource().subscribe(res => {
      if (res !== undefined && res !== '') {
        if (res.ComplaintSource_drop_down_values !== undefined && res.ComplaintSource_drop_down_values.length > 0) {
          res.ComplaintSource_drop_down_values.forEach(data => {
            this.complaintSource.push(data);
          });
        } else {
          this.errMsg = "No Complaint Source data found ";
          this.typeErr1 = true;
        }
      } else {
        this.errMsg = "No Complaint Source data found ";
        this.typeErr1 = true;
      }
    }, err => {
      this.errMsg = "Complaint Source Service " + err;
      this.typeErr1 = true;
    });
  }

  getCategory() {
    this.categories = [];
    this.complaintsDropDown.getCategory().subscribe(res => {

      if (res !== undefined && res !== '') {
        if (res.Category_drop_down_values !== undefined && res.Category_drop_down_values.length > 0) {
          res.Category_drop_down_values.forEach(data => {
            this.categories.push(data);
          });
        } else {
          this.errMsg = "No Categorys data found ";
          this.typeErr1 = true;
        }
      } else {
        this.errMsg = "No Categorys data found ";
        this.typeErr1 = true;
      }
    }, err => {
      this.errMsg = "Categorys Service " + err;
      this.typeErr1 = true;
    });
  }

  getComplaintsType() {
    this.complaintType = [];
    this.complaintsDropDown.getTypeOfComplaint().subscribe(res => {
      if (res !== undefined && res !== '') {
        if (res.ComplaintType_drop_down_values !== undefined && res.ComplaintType_drop_down_values.length > 0) {
          res.ComplaintType_drop_down_values.forEach(data => {
            this.complaintType.push(data);
          });
        } else {
          this.errMsg = "No Complaints Type data found ";
          this.typeErr1 = true;
        }
      } else {
        this.errMsg = "No Complaints Type data found ";
        this.typeErr1 = true;
      }
    }, err => {
      this.errMsg = "Complaints Type Service " + err;
      this.typeErr1 = true;
    });
  }

  incidentTimeZone(date) {
    const setTime = new Date(date);
    setTime.setHours(19);
    setTime.setMinutes(59);
    setTime.setSeconds(59);
    const estTimeZone = "America/New_York";
    const format = "YYYY-MM-DDTHH:mm:ss.SSSZ";
    var testTimeZone = momenttimezone(setTime).tz(estTimeZone).format(format);
    /*** The following logic for Daylight Savings ***/
    if (testTimeZone.includes('-05:00')) {
      testTimeZone = testTimeZone.replace('19:59:59', '18:59:59');
    }
    return testTimeZone.toString();
  }

  getActiveComplaintsDetailsToEdit() {
    this.data.ParStockNumber = this.newComplaint.complaintData.ParStockNumber,
      this.data.VIN = this.newComplaint.complaintData.VIN,
      this.data.FirstName = this.newComplaint.complaintData.FirstName,
      this.data.LastName = this.newComplaint.complaintData.LastName,
      this.data.Make = this.newComplaint.complaintData.Make,
      this.data.Model = this.newComplaint.complaintData.Model,
      this.data.Year = this.newComplaint.complaintData.Year,
      this.data.ClientName = this.newComplaint.complaintData.ClientName,
      this.data.MasterVendorName = this.newComplaint.complaintData.MasterVendorName,
      this.data.VendorLocationId = this.newComplaint.complaintData.VendorLocationId,
      this.data.ClaimStartDate = this.newComplaint.complaintData.ClaimStartDate,
      this.data.Category = this.newComplaint.complaintData.Category,
      this.data.Complainant = this.newComplaint.complaintData.Complainant,
      this.data.ComplaintType = this.newComplaint.complaintData.ComplaintType,
      this.data.RepoDate = this.newComplaint.complaintData.RepoDate,
      this.data.IncidentDate = this.newComplaint.complaintData.IncidentDate,
      this.data.ComplaintSource = this.newComplaint.complaintData.ComplaintSource,
      this.data.UserName = this.newComplaint.complaintData.UserName,
      this.data.Phone = this.newComplaint.complaintData.Phone,
      this.data.Email = this.newComplaint.complaintData.Email,
      this.editMasterVendorID = this.newComplaint.complaintData.MasterVendorId,
      this.data.Resolution = this.newComplaint.complaintData.Resolution,
      this.data.Controllable = this.newComplaint.complaintData.Controllable,
      this.data.ResolutionDate = this.newComplaint.complaintData.ResolutionDate,
      this.data.ResolutionNotes = this.newComplaint.complaintData.ResolutionNotes,
      this.data.ResolutionType = this.newComplaint.complaintData.ResolutionType,
      this.data.resolutionAmount = this.newComplaint.complaintData.ResolutionAmount,
      this.data.EmailType = this.newComplaint.complaintData.EmailType,
      this.data.SentEmail = this.newComplaint.complaintData.SentEmail == 'Y' ? true : false
    // this.data.EmailTypeVal = this.newComplaint.complaintData.EmailTypeVal
  }

  getComplaintsDetails() {
    this.data.ParStockNumber = this.newComplaint.complaintData.ParStockNumber,
      this.data.VIN = this.newComplaint.complaintData.VIN,
      this.data.FirstName = this.newComplaint.complaintData.FirstName,
      this.data.LastName = this.newComplaint.complaintData.LastName,
      this.data.Make = this.newComplaint.complaintData.Make,
      this.data.Model = this.newComplaint.complaintData.Model,
      this.data.Year = this.newComplaint.complaintData.Year,
      this.data.ClientName = this.newComplaint.complaintData.ClientName,
      this.data.MasterVendorName = this.newComplaint.complaintData.MasterVendorName,
      this.data.VendorLocationId = this.newComplaint.complaintData.VendorLocationId,
      this.data.ClaimStartDate = this.newComplaint.complaintData.ClaimStartDate,
      this.data.Category = this.newComplaint.complaintData.Category,
      this.data.Complainant = this.newComplaint.complaintData.Complainant,
      this.data.ComplaintType = null,
      this.data.RepoDate = this.newComplaint.complaintData.RepoDate,
      this.data.IncidentDate = this.newComplaint.complaintData.IncidentDate,
      this.data.ComplaintSource = null,
      this.data.UserName = this.newComplaint.complaintData.UserName,
      this.data.Phone = this.newComplaint.complaintData.Phone,
      this.data.Email = this.newComplaint.complaintData.Email,
      this.editMasterVendorID = this.newComplaint.complaintData.MasterVendorId,
      this.data.Resolution = null,
      this.data.Controllable = null,
      this.data.ResolutionDate = null,
      this.data.ResolutionNotes = null,
      this.data.EmailType = null,
      this.data.SentEmail = this.newComplaint.complaintData.SentEmail == false 
    // this.data.EmailTypeVal = null
  }

  emailTypeStatus(EmailType) {
    if (this.newComplaint.complaintData.EmailType != EmailType) {
      return true;
    } else {
      return false;
    }
  }

  onFormSubmit(form: NgForm) {
    if (this.newComplaint.type === 'update') {
      const editLocalData = form.value;
      if (this.newComplaint.status == 0) {
        if (editLocalData.Completed == true) {
          this.complaintValue = 1;
          this.updateList = "inactive"
        } else {
          this.complaintValue = 0;
          this.updateList = "active"
        }
      } else if (this.newComplaint.status == 1) {
        if (editLocalData.ComplaintStatus === true) {
          this.complaintValue = 1;
          this.updateList = "inactive"
        } else if (editLocalData.ComplaintStatus === false) {
          this.complaintValue = 0;
          this.updateList = "active"
        }
      }

      this.editData = {
        "MasterVendorId": this.editMasterVendorID,
        "VendorLocationId": editLocalData.VendorLocationId,
        "Category": editLocalData.Category,
        "Complainant": editLocalData.Complainant,
        "ComplaintType": editLocalData.ComplaintType,
        "IncidentDate": this.incidentTimeZone(this.data.IncidentDate),
        "ComplaintSource": editLocalData.ComplaintSource,
        "UserName": editLocalData.UserName,
        "Phone": editLocalData.Phone,
        "Email": editLocalData.Email,
        "State": '',
        "ComplaintStatus": this.complaintValue,
        "Resolution": editLocalData.Resolution,
        "ResolutionAmount": (editLocalData.resolutionAmount == '' || editLocalData.resolutionAmount == null) ? 0 : editLocalData.resolutionAmount,
        "ResolutionType": (editLocalData.ResolutionType == '' || editLocalData.ResolutionType == null || editLocalData.ResolutionType == undefined) ? '' : editLocalData.ResolutionType,
        "Controllable": editLocalData.Controllable,
        "MasterVendorName": editLocalData.MasterVendorName,
        "ResolutionDate": (editLocalData.ResolutionDate == '') ? '' : this.incidentTimeZone(editLocalData.ResolutionDate),
        "ResolutionNotes": editLocalData.ResolutionNotes,
        "EmailType": editLocalData.EmailType,
        // "EmailTypeVal": this.emailTypeval,
        "VendorEmail": this.vendorEmailId,
        "EmailTypeChangeStatus": this.emailTypeStatus(editLocalData.EmailType),
        "VIN": this.newComplaint.complaintData.VIN != '' ? this.newComplaint.complaintData.VIN : '',
        "ParStockNumber": this.newComplaint.complaintData.ParStockNumber != '' ? this.newComplaint.complaintData.ParStockNumber : '',
        "FirstName": this.newComplaint.complaintData.FirstName != '' ? this.newComplaint.complaintData.FirstName : '',
        "LastName": this.newComplaint.complaintData.LastName != '' ? this.newComplaint.complaintData.LastName : '',
        "SentEmail": editLocalData.SentEmail ===  true ? 'Y' : 'N'        
      }
      this.vendorLocationList.forEach(vendorData => {
        if (vendorData.LocationId === editLocalData.VendorLocationId) {
          this.editData.State = vendorData.State;
        }
      })

      this.cmpId = this.newComplaint.complaintData.ComplaintId;
      this.manageComplaint.updateManageComplaint(this.editData, this.cmpId).subscribe(res => {
        ga('CompliantsTracker.send', 'event', this.firstName + ' ' + this.lastName, environment.googleAnalyticsEvents[1], this.editData.UserName, 10);
        // this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName,environment.googleAnalyticsEvents[1],this.editData.UserName, 1);
        if (this.editData.ComplaintStatus == 0 && this.updateList == "active") {
          this.manageComplaint.load.next('updated active complaint');
        } else if (this.editData.ComplaintStatus == 1 && this.updateList == "inactive") {
          this.manageComplaint.load.next('updated inactive complaint');
        } else if (this.editData.ComplaintStatus == 0 && this.updateList == "inactive") {
          this.manageComplaint.load.next('updated inactive complaint');
        }
        this.dialogRef.close();
      }, error => {
        this.ManageTypeErrMsg = 'Manage Complaints Service' + ' ' + error;
        this.ManageTypeErr = true;
      });
    } else if (this.newComplaint.type === 'relate') {
      const relateFormData = form.controls;
      this.relateComplaintData = {
        "ParStockNumber": relateFormData.ParStockNumber.value,
        "VIN": relateFormData.VIN.value,
        "FirstName": relateFormData.FirstName.value,
        "LastName": relateFormData.LastName.value,
        "Make": relateFormData.Make.value,
        "Model": relateFormData.Model.value,
        "Year": relateFormData.Year.value,
        "ClientName": relateFormData.ClientName.value,
        "MasterVendorId": this.editMasterVendorID,
        "MasterVendorName": relateFormData.MasterVendorName.value,
        "VendorLocationId": relateFormData.VendorLocationId.value,
        "Category": relateFormData.Category.value,
        "Complainant": relateFormData.Complainant.value,
        "ComplaintType": relateFormData.ComplaintType.value,
        "IncidentDate": this.incidentTimeZone(this.data.IncidentDate),
        "RepoDate": (this.data.RepoDate == "") ? null : this.data.RepoDate,
        "ComplaintSource": relateFormData.ComplaintSource.value,
        "UserName": relateFormData.UserName.value,
        "Phone": relateFormData.Phone.value,
        "Email": relateFormData.Email.value,
        "CreatedBy": this.loginId,
        "State": '',
        "RelatedComplaintId": this.newComplaint.complaintData.ComplaintId,
        "EmailType": relateFormData.EmailType.value,
        // "EmailTypeVal": this.emailTypeval,
        "VendorEmail": this.vendorEmailId,
        "SentEmail": relateFormData.SentEmail.value ===true ? 'Y' : 'N' 
      
      }
      this.vendorLocationList.forEach(vendorData => {
        if (vendorData.LocationId === relateFormData.VendorLocationId.value) {
          this.relateComplaintData.State = vendorData.State;
        }
      })
      this.manageComplaint.submitManageComplaint(this.relateComplaintData).subscribe(res => {
        // this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName,environment.googleAnalyticsEvents[6],this.relateComplaintData.UserName, 1);
        ga('CompliantsTracker.send', 'event', this.firstName + ' ' + this.lastName, environment.googleAnalyticsEvents[6], this.relateComplaintData.UserName, 10);
        if (this.newComplaint.type === 'relate' && this.newComplaint.status === 0) {
          this.manageComplaint.load.next('Active Relate Complaint');
        } else if (this.newComplaint.type === 'relate' && this.newComplaint.status === 1) {
          this.manageComplaint.load.next('InActive Relate Complaint');
        }
        this.dialogRef.close();
      }, error => {
        this.ManageTypeErrMsg = 'Manage Complaints Service' + ' ' + error;
        this.ManageTypeErr = true;
      });
    } else {
      const datalocal = this.data;
      this.submitFormData = {
        "ParStockNumber": datalocal.ParStockNumber,
        "VIN": datalocal.VIN,
        "FirstName": (datalocal.FirstName == null) ? '' : datalocal.FirstName,
        "LastName": (datalocal.LastName == null) ? '' : datalocal.LastName,
        "Make": (datalocal.Make == null) ? '' : datalocal.Make,
        "Model": (datalocal.Model == null) ? '' : datalocal.Model,
        "Year": (datalocal.Year == null) ? '' : datalocal.Year,
        "ClientName": (datalocal.ClientName == null) ? '' : datalocal.ClientName,
        "MasterVendorId": this.editMasterVendorID,
        "MasterVendorName": datalocal.MasterVendorName,
        "VendorLocationId": datalocal.VendorLocationId,
        "Category": datalocal.Category,
        "Complainant": datalocal.Complainant,
        "ComplaintType": datalocal.ComplaintType,
        "RepoDate": (this.data.RepoDate == "null") ? null : this.data.RepoDate,
        "IncidentDate": this.incidentTimeZone(this.data.IncidentDate),
        "ComplaintSource": datalocal.ComplaintSource,
        "UserName": datalocal.UserName,
        "Phone": datalocal.Phone,
        "Email": datalocal.Email,
        "CreatedBy": this.loginId,
        "State": '',
        "EmailType": datalocal.EmailType,
        "SentEmail": datalocal.SentEmail === true ? 'Y' : 'N',
        // "EmailTypeVal": this.emailTypeval,
        "VendorEmail": this.vendorEmailId
      }
      this.vendorLocationList.forEach(vendorData => {
        if (vendorData.LocationId === datalocal.VendorLocationId) {
          this.submitFormData.State = vendorData.State;
        }
      })
      this.manageComplaint.submitManageComplaint(this.submitFormData).subscribe(res => {
        ga('CompliantsTracker.send', 'event', this.firstName + ' ' + this.lastName, environment.googleAnalyticsEvents[0], this.submitFormData.UserName, 10);
        // this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName,environment.googleAnalyticsEvents[0],this.submitFormData.UserName, 1);
        this.manageComplaint.load.next('Added Complaint');
        this.dialogRef.close();
      }, error => {
        this.ManageTypeErrMsg = 'Manage Complaints Service' + ' ' + error;
        this.ManageTypeErr = true;
      });
    }
  }

  onNoClick() {
    this.dialogRef.close();
  }

  CompletedChecked(event) {
    if (event.target.checked === true) {
      this.IsCompletedChecked = true;
    } else {
      this.IsCompletedChecked = false;
    }
  }

  selectedResolution(event) {
    if (event.value) {
      if (event.value == 'Other' || event.value == 'N/A') {
        this.isResolutionHidden = false;
      } else {
        this.isResolutionHidden = true;
      }
    }
  }

  ngOnDestroy() {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
}

export interface controllableList {
  value: string;
}



// WEBPACK FOOTER //
// ./src/app/components/new-complaints-dialog/new-complaints-dialog.component.ts